import React, { Fragment, useState } from 'react'
import styled from 'styled-components'
import classNames from 'classnames'
import { Grid, Col, Row } from 'react-styled-flexboxgrid'

import Text from 'components/Atoms/Text'
import { Trans, useTranslation } from 'i18n-web/i18next'

import Item from './Item'

const Component = styled.section`
  padding: 60px 0;

  .row {
    margin: 0;
  }

  .col {
    padding: 0;
  }

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}rem) {
    padding: 80px 0;

    .answers {
      padding-left: 30px;
    }
  }
`

const Title = styled(Text)`
  margin-bottom: 20px;
  font-size: ${props => props.theme.font.size.mobile.h3};
  color: ${props => props.theme.palette.grayDark};
  text-transform: uppercase;

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}rem) {
    margin-bottom: 40px;
    font-size: ${props => props.theme.font.size.desktop.h3};
  }
`

const FAQ = () => {
  const { t } = useTranslation()

  const [isActive, setIsActive] = useState(0)

  const list = [
    {
      answer: t('howItWorks.faq.question1.answer'),
      question: t('howItWorks.faq.question1.question'),
    },
    {
      answer: t('howItWorks.faq.question2.answer'),
      question: t('howItWorks.faq.question2.question'),
    },
    {
      answer: t('howItWorks.faq.question3.answer'),
      question: t('howItWorks.faq.question3.question'),
    },
    {
      answer: t('howItWorks.faq.question4.answer'),
      question: t('howItWorks.faq.question4.question'),
    },
    {
      answer: <Trans i18nKey="howItWorks.faq.question5.answer" />,
      question: t('howItWorks.faq.question5.question'),
    },
  ]

  return (
    <Component>
      <Grid>
        <Row>
          <Col xs={12}>
            <Title as="h2" className="bold uppercase grayDark">
              {t('howItWorks.faq.title')}
            </Title>
            <Row className="row">
              <Col className="col" xs={12} sm={6}>
                <ul>
                  {list.map((item, index) => (
                    <Fragment key={index}>
                      <Item
                        className={classNames({
                          last: index === list.length - 1,
                        })}
                        onClick={() => setIsActive(index)}
                        item={item}
                        active={index == isActive}
                      />
                      <Item
                        answer
                        className="mobile"
                        key={`answerMobile-${index}`}
                        item={item}
                        active={index == isActive}
                      />
                    </Fragment>
                  ))}
                </ul>
              </Col>
              <Col className="col answers" xs={false} sm={6}>
                <ul>
                  {list.map((item, index) => (
                    <Item
                      answer
                      key={`answer-${index}`}
                      item={item}
                      onClick={() => setIsActive(index)}
                      active={index == isActive}
                    />
                  ))}
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>
      </Grid>
    </Component>
  )
}

export default FAQ
